import Crud from '../views/Comorbidade/Crud'
import Entity from '../views/Comorbidade/Add'

let routes = {
    path: '/comorbidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/comorbidades/add',
            name: 'NewComorbidade',
            component: Entity,
            meta: {
                pageTitle: 'Comorbidade',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Adicionar Comorbidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/comorbidades/edit/:id?',
            name: 'EditComorbidade',
            component: Entity,
            meta: {
                pageTitle: 'Comorbidade',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Editar Comorbidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/comorbidades',
            name: 'list-comorbidades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Comorbidades',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Comorbidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes